import { gql } from "lib/apolloClient";
import { studentsAlertFragment } from "modules/CommonFragments";
import { projectDetailFragment } from "../../../modules/AssessmentFragments";

export const gradebookInfoFragment = gql`
  fragment gradebookInfo on Project {
    id
    students {
      id
      profileImage
      firstName
      middleName
      lastName
      preferredName
      suffix
      pronouns
      alertTypes {
        ...alertTypeFields
      }
      ibPYPElementRatings(
        dataSet: PROJECT_ASSESSMENT
        filtersForGeneric: $filtersForGeneric
      ) {
        id
        ibPYPElementId
        ibPYPElementType
        value
        academicCriteriaSet {
          id
          label
          criteriaType
        }
        academicCriteriaValue {
          id
          label
          abbreviation
        }
      }
    }
    toolResponses(userFilter: ALL) {
      id
      rowId
      columnId
      subjectiveResponse
      creatorType
    }
    ibPYPElementRemarks {
      id
      message
      ibPYPElementId
      ibPYPElementType
    }
    ...projectDetailItem
  }
  ${projectDetailFragment}
  ${studentsAlertFragment}
`;
